module.exports = __webpack_public_path__ + "img/PARIMATCH.UK.c1cdf75b.svg";